import logo from "../assets/logo/logo.png";
import visa from "../assets/logo/Visa.png";
import mastercard from "../assets/logo/Mastercard.png";
import paypal from "../assets/logo/Paypal.png";
import bancontact from "../assets/logo/Bancontact.png";
import ideal from "../assets/logo/ideal.svg";
import { CONTACT_CONFIG } from "../config/contact";

export default function Footer() {
  const { 
    phoneNumber: PHONE_NUMBER, 
    email: EMAIL, 
    whatsappUrl: WHATSAPP_URL, 
    companyName: COMPANY_NAME 
  } = CONTACT_CONFIG;
  return (
    <footer className="bg-gradient-to-br from-[#04003b] via-[#090979] to-[#00d4ff] text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white to-transparent transform -skew-y-1"></div>
      </div>

      {/* Upper Section */}
      <div className="main-content w-[95%] sm:w-[90%] md:w-[85%] m-auto py-8 sm:py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Left Column - Logo and Description */}
          <div className="lg:col-span-1">
            <a
              href="/"
              className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4"
            >
              <img
                src={logo}
                alt="Logo"
                loading="lazy"
                className="footer-logo w-10 h-auto md:w-12 md:h-auto"
              />
              <span className="text-lg sm:text-xl font-bold text-white">
                {COMPANY_NAME}
              </span>
            </a>
            <p className="text-blue-100 leading-relaxed text-sm sm:text-base">
              Wij bieden de beste IPTV-diensten. Onze service is
              eenvoudig, snel en betrouwbaar. Geniet van je favoriete
              zenders op elk apparaat, waar je ook bent.
            </p>
          </div>

          {/* Middle Column - Quick Links */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">
              Snelle Links
            </h3>
            <div className="w-10 sm:w-12 h-1 bg-white mb-3 sm:mb-4"></div>
            <ul className="space-y-1.5 sm:space-y-2">
              <li>
                <a
                  href="/refundpolicy"
                  className="text-blue-100 hover:text-white transition-colors duration-300 text-sm sm:text-base"
                >
                  Restitutiebeleid
                </a>
              </li>
              <li>
                <a
                  href="/privacypolicy"
                  className="text-blue-100 hover:text-white transition-colors duration-300 text-sm sm:text-base"
                >
                  Privacybeleid
                </a>
              </li>
              <li>
                <a
                  href="/termsandconditions"
                  className="text-blue-100 hover:text-white transition-colors duration-300 text-sm sm:text-base"
                >
                  Algemene Voorwaarden
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">
              Contact
            </h3>
            <div className="w-10 sm:w-12 h-1 bg-white mb-3 sm:mb-4"></div>
            <div className="space-y-2 sm:space-y-3">
              <div className="flex items-center gap-2 sm:gap-3">
                <svg
                  className="text-white w-4 h-4 sm:w-5 sm:h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <span className="text-blue-100 text-sm sm:text-base">
                  {EMAIL}
                </span>
              </div>
              <div className="flex items-center gap-2 sm:gap-3">
                <svg
                  className="text-white w-4 h-4 sm:w-5 sm:h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <span className="text-blue-100 hover:text-white transition-colors duration-300 text-sm sm:text-base">
                  <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    {PHONE_NUMBER}
                  </a>
                </span>
              </div>
            </div>
          </div>

          {/* Right Column - Payment Methods */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">
              Wij accepteren
            </h3>
            <div className="w-10 sm:w-12 h-1 bg-white mb-3 sm:mb-4"></div>
            <div className="grid grid-cols-5 gap-2">
              <div className="bg-white/10 backdrop-blur-sm rounded-md sm:rounded-lg p-1.5 sm:p-2 flex items-center justify-center border border-white/20 hover:bg-white/20 transition-all duration-300">
                <img
                  src={ideal}
                  alt="iDEAL"
                  loading="lazy"
                  className="h-6 sm:h-8 w-auto"
                />
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-md sm:rounded-lg p-1.5 sm:p-2 flex items-center justify-center border border-white/20 hover:bg-white/20 transition-all duration-300">
                <img
                  src={paypal}
                  alt="PayPal"
                  loading="lazy"
                  className="h-6 sm:h-9 w-auto"
                />
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-md sm:rounded-lg p-1.5 sm:p-2 flex items-center justify-center border border-white/20 hover:bg-white/20 transition-all duration-300">
                <img
                  src={visa}
                  alt="VISA"
                  loading="lazy"
                  className="h-3 sm:h-4 w-auto"
                />
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-md sm:rounded-lg p-1.5 sm:p-2 flex items-center justify-center border border-white/20 hover:bg-white/20 transition-all duration-300">
                <img
                  src={mastercard}
                  alt="MasterCard"
                  loading="lazy"
                  className="h-4 sm:h-6 w-auto"
                />
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-md sm:rounded-lg p-1.5 sm:p-2 flex items-center justify-center border border-white/20 hover:bg-white/20 transition-all duration-300">
                <img
                  src={bancontact}
                  alt="Bancontact"
                  loading="lazy"
                  className="h-4 sm:h-6 w-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lower Section - Bottom Bar */}
      <div className="border-t border-white/20">
        <div className="main-content py-3 sm:py-4">
          <div className="text-xs sm:text-sm text-center text-blue-100 mb-1 sm:mb-2 md:mb-0">
            © {COMPANY_NAME} - {EMAIL}
          </div>
        </div>
      </div>
    </footer>
  );
}
